import { TestRoutineOverlay } from '#app/routes/mocra+/_form+/components/test-routines/overlay.tsx'
import { type TestRoutineDraft } from '#app/routes/mocra+/_form+/components/test-routines/types.ts'

type Props = {
	readonly open: boolean
	readonly onOpenChange: (open: boolean) => void
	readonly onSubmit: (draft: TestRoutineDraft) => void
	readonly initialValue: TestRoutineDraft
	readonly onClosed?: () => void
	readonly onCancel?: () => void
}

export function TestRoutineEditOverlay({
	open,
	onOpenChange,
	onSubmit,
	initialValue,
	onClosed,
	onCancel,
}: Props) {
	return (
		<TestRoutineOverlay
			mode="edit"
			open={open}
			onOpenChange={onOpenChange}
			onSubmit={onSubmit}
			initialValue={initialValue}
			onClosed={onClosed}
			onCancel={onCancel}
		/>
	)
}
